
import { create } from 'zustand';

export interface User {
  head?: string;
  uid: string;
  role: string;
  designation: string;
  status: string;
  email: string;
  name: string;
  created_at?: string;
  core_metrics?: {
    decision_maker_discovery: number;
    timeline_discovery: number;
    rapport_setting_expectations: number;
    next_step_commitment: number;
    pain_extraction: number;
  };
}

interface UserStore {
  user: User | null;
  setUser: (user: User | null) => void;
  clearUser: () => void;
}

export const useUserStore = create<UserStore>((set) => ({
  user: null,
  setUser: (user) => set({ user }),
  clearUser: () => set({ user: null }),
}));
